/**
 * Optional dashboard areas toggled by super admin per customer (company.settings.navFeatures).
 * Omitted keys inherit DEFAULT_NAV_FEATURES (audit + programmes on for pilot customers).
 */
/** Pilot defaults: audit programme + audit events visible unless explicitly disabled. */
export const DEFAULT_NAV_FEATURES = {
  audit: true,
  programs: true,
  performance: false
};

export function getResolvedNavFeatures(company) {
  const merged = { ...DEFAULT_NAV_FEATURES, ...(company?.settings?.navFeatures || {}) };
  return {
    audit: !!merged.audit,
    programs: !!merged.programs,
    performance: !!merged.performance
  };
}
